import { PencilIcon, PlusIcon } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { CommonLink } from '../common/CommonLink';
import { useChannelStore } from './ChannelProvider';
import { twMerge } from 'tailwind-merge';
import webViewStore from '../../stores/webViewStore';

export const PostButton = observer(({ className }: { className?: string }) => {
    const channel = useChannelStore();

    if (!channel.canWrite) {
        return null;
    }

    return (
        <CommonLink
            to={`/channel/${channel.channelType}/editor`}
            className={twMerge(
                'btn btn-soft btn-primary flex size-14 items-center justify-center rounded-full p-0',
                className,
            )}
        >
            <PencilIcon className="size-5" />
        </CommonLink>
    );
});

export const FloatingPostButton = observer(() => {
    return (
        <PostButton
            className={twMerge(
                'fixed right-5 bottom-5 z-(--z-index-floating-item) shadow-sm',
                !webViewStore.isWebView && 'hidden-when-desktop',
            )}
        />
    );
});
